import { useState, useEffect } from 'react';
import { getStaticFileUrl } from '../config/api';

export const usePhotoBase64 = (photoPath) => {
  const [photoBase64, setPhotoBase64] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!photoPath) {
      setPhotoBase64(null);
      setLoading(false);
      setError(null);
      return;
    }

    const loadPhoto = async () => {
      setLoading(true);
      setError(null);
      try {
        // Extraire le nom du fichier du chemin
        const filename = photoPath.split('/').pop();
        const photoUrl = getStaticFileUrl(filename);
        
        console.log('Chargement photo:', { photoPath, filename, photoUrl });
        
        // Charger l'image pour vérifier qu'elle existe
        const img = new Image();
        img.crossOrigin = 'anonymous';
        
        img.onload = () => {
          console.log('Photo chargée avec succès:', photoUrl);
          setPhotoBase64(photoUrl);
          setLoading(false);
        };
        
        img.onerror = (err) => {
          console.error('Erreur de chargement de l\'image:', err);
          setError(new Error('Impossible de charger l\'image'));
          setPhotoBase64(null);
          setLoading(false);
        };
        
        img.src = photoUrl;
        
      } catch (err) {
        console.error('Erreur lors du chargement de la photo:', err);
        setError(err);
        setPhotoBase64(null);
        setLoading(false);
      }
    };

    loadPhoto();
  }, [photoPath]);

  return { photoBase64, loading, error };
}; 